import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './campaign.less'

import ProfileHeader from 'components/pages/campaign/profile_header'
import PayPalPage from 'components/common/paypal_page'
import CampaignTitle from 'components/pages/campaign/campaign_title'
import WhiteBox from 'components/pages/campaign/white_box'
import CampaignDetails from 'components/pages/campaign/campaign_details'
import CampaignInfo from 'components/pages/campaign/campaign_info'
import CampaignAction from 'components/pages/campaign/campaign_action'
import Share from 'components/pages/campaign/share'
import Start from 'components/pages/campaign/start_your_own'
import PublicContributionsList from 'components/contributions_list/public_contributions_list'
import WhiteHeader from 'components/pages/campaign/white_header'
import Separator from 'components/common/separator'
import ModalAnimations from 'components/common/transitions/modal_animations'
import NoCurrencyAlert from 'components/pages/campaign/no_currency_alert'
import ReportLink from 'components/pages/campaign/report_link'

class CampaignPage extends React.Component {
  static propTypes = {
    campaignId: PropTypes.string,
    title: PropTypes.string,
    preview: PropTypes.bool,
    isOwner: PropTypes.bool,
    whiteHeaderElement: PropTypes.any,
    children: PropTypes.any,
    backgroundImage: PropTypes.string,
    onShowComingSoon: PropTypes.func,
    glimpse: PropTypes.element,
    hasCurrencyBalance: PropTypes.bool,
    currency: PropTypes.string,
    canCreate: PropTypes.bool,
    hasBalance: PropTypes.bool,
    canManage: PropTypes.bool,
  }

  static defaultProps = {
    canManage: false,
  }

  handleShareClick = event => {
    if (this.props.preview) {
      event.preventDefault()
      this.setState({ showPreviewDialog: true })
    }
  }

  render() {
    let {
      whiteHeaderElement,
      isOwner,
      preview,
      hasCurrencyBalance,
      canCreate,
      currency,
      canManage,
    } = this.props

    let alertElement = null
    if (!preview && isOwner && !hasCurrencyBalance) {
      alertElement = <NoCurrencyAlert currency={currency} />
    }

    const showManage = canManage && !this.props.preview
    const customProfileHeader = !whiteHeaderElement && !isOwner

    return (
      <div>
        {/* Render a glimpse if there is one */}
        <ModalAnimations>{this.props.glimpse}</ModalAnimations>

        {whiteHeaderElement && (
          <WhiteHeader>
            {React.createElement(whiteHeaderElement, {
              campaignId: this.props.campaignId,
            })}
          </WhiteHeader>
        )}

        <PayPalPage showHeader={isOwner}>
          <ProfileHeader
            campaignId={this.props.campaignId}
            showHeader={customProfileHeader}
            showHubLink={showManage}
          />
          <div styleName="campaign-grid-container">
            {alertElement && (
              <div styleName="campaign-grid-row" className="hidden-xs">
                <div styleName="alert-col">{alertElement}</div>
              </div>
            )}
            <div styleName="campaign-grid-row">
              <div styleName="campaign-left-part">
                <CampaignTitle campaignId={this.props.campaignId} />
              </div>
              {alertElement && (
                <div styleName="campaign-grid-row" className="visible-xs-block">
                  <div styleName="alert-col">{alertElement}</div>
                </div>
              )}
              <div styleName="campaign-right-part">
                <CampaignAction
                  isOwner={isOwner}
                  showFixedGradient={customProfileHeader}
                  showManageButton={showManage}
                  preview={preview}
                  campaignTitle={this.props.title}
                  campaignId={this.props.campaignId}
                />
              </div>
            </div>
            <div styleName="campaign-grid-row" className="hidden-xs">
              <div styleName="separator-col">
                <Separator type="dotted" />
              </div>
            </div>
            <div styleName="campaign-grid-row">
              <div styleName="campaign-left-part">
                <div styleName="chip-container-left">
                  <WhiteBox>
                    <CampaignInfo campaignId={this.props.campaignId} />
                  </WhiteBox>
                </div>
                <WhiteBox>
                  <CampaignDetails campaignId={this.props.campaignId} />
                </WhiteBox>
                <WhiteBox>
                  <PublicContributionsList
                    campaignId={this.props.campaignId}
                    onChipInClick={this.handleChipInClick}
                  />
                </WhiteBox>
              </div>
              <div styleName="campaign-right-part">
                <div styleName="chip-container-right">
                  <WhiteBox>
                    <CampaignInfo campaignId={this.props.campaignId} />
                  </WhiteBox>
                </div>
                <WhiteBox>
                  <Share
                    campaignId={this.props.campaignId}
                    onClickOverride={this.handleShareClick}
                  />
                </WhiteBox>
                {!preview &&
                  canCreate && (
                    <WhiteBox>
                      <Start />
                    </WhiteBox>
                  )}
                {!preview && !isOwner && <ReportLink />}
              </div>
            </div>
          </div>
        </PayPalPage>
      </div>
    )
  }
}

export default cssModules(CampaignPage, styles, { allowMultiple: true })
